function toggleMenu(e) {
    let menuButtons = document.querySelectorAll("[aria-controls]")
    var menuButton = e.currentTarget
    var menu = document.getElementById(menuButton.getAttribute('aria-controls'));
    if (menu.ariaExpanded == "true") {
        menu.ariaExpanded = false;
        menuButton.classList.remove("expanded")
    } else if (menu.ariaExpanded == "false") {
        menuButtons.forEach(function(menuButton) {
            document.getElementById(menuButton.getAttribute('aria-controls')).ariaExpanded = false;
        })
        menuButton.classList.add("expanded")
        menu.ariaExpanded = true;
    }
}
let menuButtons = document.querySelectorAll("[aria-controls]")
menuButtons.forEach(function(menuButton) {
    menuButton.addEventListener('click', toggleMenu, false)
})

if (document.getElementById('scheduleNowCTA')) {
  ctatab = document.querySelector('header .md\\:fixed')
  ctatab.classList.replace("md:fixed", "md:absolute")
}
